import { Link } from "react-router-dom";

const CLASS =
  "px-4 py-1.5 text-left text-sm text-muted-foreground hover:text-foreground hover:underline";

// "More (N) →" funnel. See DESIGN.md "'More' funnel". N is the backend total.
// With `to` it links to the full filtered list page; with `onClick` it expands
// the list in place instead.
export const MoreLink = ({
  to,
  total,
  onClick,
}: {
  to?: string;
  total: number;
  onClick?: () => void;
}) =>
  to ? (
    <Link to={to} className={CLASS}>
      More ({total}) →
    </Link>
  ) : (
    <button type="button" onClick={onClick} className={CLASS}>
      More ({total}) →
    </button>
  );

export default MoreLink;
